import {
  ModbusWriteCoilScheduleEventCommandConfig,
  ScheduleEventDeviceConfig,
} from '@thingslog/repositories';
import { EventConfigFactory } from './EventConfigFactory';

export class ModbusWriteCoilFactory implements EventConfigFactory {
  public create(deviceNumbers: string[]): ModbusWriteCoilScheduleEventCommandConfig {
    return {
      '@type': 'MODBUS_WRITE_COIL',
      deviceCommand: 'MODBUS',
      modbusCommandTag: '5',
      deviceNumbers,
      sensorIndex: 0,
      slaveDeviceNumber: '',
      relayState: 'OFF',
    };
  }
}
